/* ============================================================
   TENFIT Landing · Mes del Padre
   Vanilla JS — AISLADO: opera solo dentro de [data-lp-mpd]
   ============================================================ */
(function () {
  'use strict';

  /* ---- Formato de precios COP ---- */
  var COP = function (n) {
    return '$' + Number(n / 100).toLocaleString('es-CO');
  };

  /* ---- Mapa de colores para swatches ---- */
  var COLOR_HEX = {
    'Blanco': '#eef0f2', 'Azul Rey': '#1b46d6', 'Azul Turquí': '#1f86c0',
    'Azul Petróleo': '#1d5e74', 'Azul Oscuro': '#15243c', 'Azul Oscuro Jaspe': '#27384f',
    'Gris Claro': '#b9c0c6', 'Gris Jaspe': '#8b9298', 'Gris Oscuro': '#3b4046',
    'Gris Plata': '#aab0b6', 'Verde Jade': '#1f6b4f', 'Verde Militar': '#4b5320',
    'Verde Jaspe': '#4d5b33', 'Verde Salvia': '#9aab93', 'Verde Menta': '#9fd3c0',
    'Vinotinto': '#5e1322', 'Vinotinto Oscuro': '#5e1322', 'Rojo': '#d12b2b',
    'Amarillo Neón': '#cfe233', 'Café Castaña': '#8a4b2a', 'Caquí Claro': '#d8c69a',
    'Caquí Oscuro': '#7d7044', 'Hortensia': '#8aa0c4', 'Negro': '#14181d',
    'Morado': '#5a2a86', 'Salmón': '#f08a7a', 'Rosa Crepé': '#e7a9bf'
  };

  /* ---- Scroll suave ---- */
  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* ---- Toast ---- */
  var toastTimer;
  function showToast(msg) {
    var t = document.querySelector('.lp-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'lp-toast';
      t.innerHTML = '<span class="lp-t-ic">✓</span><span class="lp-t-msg"></span>';
      document.body.appendChild(t);
    }
    t.querySelector('.lp-t-msg').textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ---- Actualizar contador del carrito en el tema ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var selectors = [
          '[data-lp-cart-count]', '.cart-count', '.cart__count',
          '#cart-count', '[data-cart-count]', '.js-cart-count'
        ];
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.textContent = count;
          });
        });
      });
  }

  /* ---- Refrescar Smart Cart via PageFly + fallback ---- */
  function refreshThemeCart() {
    /* 1. PageFly cart functions — integradas con el Smart Cart */
    if (typeof window._pf_getCart === 'function') {
      try { window._pf_getCart(function () {}); } catch (e) {}
    }
    if (typeof window._pf_ajaxCartUpdate === 'function') {
      try { window._pf_ajaxCartUpdate({}); } catch (e) {}
    }

    /* 2. Eventos estándar Shopify */
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:item_added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      window.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });

    /* 3. Fallback: cerrar drawer y reabrirlo via botón del nav */
    setTimeout(function () {
      var closeBtn = document.querySelector('[data-corvu-drawer-close]');
      if (closeBtn) {
        closeBtn.click();
        setTimeout(function () {
          var btn = document.querySelector('.m-cart-icon-bubble');
          if (btn) btn.click();
        }, 500);
      }
    }, 250);
  }

  /* ---- Agregar variante al carrito de Shopify ---- */
  function addVariantToCart(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
    }).then(function (res) {
      if (!res.ok) throw new Error('Error al agregar al carrito');
      return res.json();
    });
  }

  /* ---- Builder ---- */
  var builderState = { comboId: null, selections: {} };

  function initBuilder(root) {
    var cardEl = root.querySelector('#lp-build-card');
    if (!cardEl) return;

    var combos = ((window.__lpMpd || {}).combos) || [];
    if (!combos.length) return;

    builderState.comboId = combos[0].id;
    combos.forEach(function (c) { builderState.selections[c.id] = {}; });

    renderCard(cardEl, combos);
  }

  function renderCard(cardEl, combos) {
    var combo = combos.find(function (c) { return c.id === builderState.comboId; });
    if (!combo) return;

    var sel = builderState.selections[combo.id] || {};
    if (!sel.size && combo.sizes && combo.sizes.length) sel.size = combo.sizes[0];

    var colorOpts = combo.options.filter(function (o) {
      return o.name.toLowerCase() !== 'talla';
    });

    var swatchesHtml = colorOpts.map(function (opt, gi) {
      var currentColor = sel['opt' + gi] || opt.values[0];
      return '<div class="lp-bc-garment">' +
        '<div class="lp-bg-label">' +
          '<span class="lp-bg-name">' + opt.name + '</span>' +
          '<span class="lp-bg-color" data-lp-color-label="' + gi + '">' + currentColor + '</span>' +
        '</div>' +
        '<div class="lp-swatches">' +
          opt.values.map(function (v) {
            return '<button class="lp-swatch' + (v === currentColor ? ' is-sel' : '') + '"' +
              ' title="' + v + '"' +
              ' data-lp-swatch="' + gi + '"' +
              ' data-lp-color="' + v + '"' +
              ' style="background:' + (COLOR_HEX[v] || '#ccc') + '"></button>';
          }).join('') +
        '</div>' +
      '</div>';
    }).join('');

    var priceNormal = combo.comparePrice || 0;
    var priceSave   = priceNormal - combo.price;

    /* Vista dividida: mitad izquierda = prenda 1, mitad derecha = prenda 2 */
    var imgMap      = buildImageMap(combo.images || []);
    var initColor0  = sel['opt0'] || (colorOpts[0] && colorOpts[0].values[0]) || '';
    var initColor1  = sel['opt1'] || (colorOpts[1] && colorOpts[1].values[0]) || '';
    var img0 = (imgMap.prenda1 && imgMap.prenda1[initColor0]) || combo.image || '';
    var img1 = (imgMap.prenda2 && imgMap.prenda2[initColor1]) || combo.image || '';

    cardEl.innerHTML =
      '<div class="lp-build-photo">' +
        '<div class="lp-bp-half lp-bp-left">' +
          (img0 ? '<img src="' + img0 + '" alt="' + (colorOpts[0] ? colorOpts[0].name : '') + '" data-lp-photo="0" loading="lazy">' : '') +
          (colorOpts[0] ? '<span class="lp-bp-half-label">' + colorOpts[0].name + '</span>' : '') +
        '</div>' +
        '<div class="lp-bp-divider"></div>' +
        '<div class="lp-bp-half lp-bp-right">' +
          (img1 ? '<img src="' + img1 + '" alt="' + (colorOpts[1] ? colorOpts[1].name : '') + '" data-lp-photo="1" loading="lazy">' : '') +
          (colorOpts[1] ? '<span class="lp-bp-half-label">' + colorOpts[1].name + '</span>' : '') +
        '</div>' +
        '<div class="lp-bp-tag">' + combo.title + '</div>' +
      '</div>' +
      '<div class="lp-build-config">' +
        '<h3>' + combo.title + '</h3>' +
        swatchesHtml +
        '<div class="lp-bc-garment">' +
          '<div class="lp-bg-label">' +
            '<span class="lp-bg-name">Talla</span>' +
            '<div class="lp-talla-right">' +
              '<span class="lp-bg-color" data-lp-size-label>' + (sel.size || '') + '</span>' +
              (combo.sizeGuide
                ? '<button class="lp-size-guide-btn" data-lp-size-guide="' + combo.sizeGuide + '">' +
                    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12h20M2 12l4-4M2 12l4 4M22 12l-4-4M22 12l-4 4"/></svg>' +
                    ' Guía de tallas' +
                  '</button>'
                : '') +
            '</div>' +
          '</div>' +
          '<div class="lp-bc-sizes">' +
            (combo.sizes || []).map(function (s) {
              return '<button class="lp-size-chip' + (s === sel.size ? ' is-sel' : '') + '"' +
                ' data-lp-size="' + s + '">' + s + '</button>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<div class="lp-bc-foot">' +
          '<div class="lp-bc-price">' +
            '<div class="lp-pp-row">' +
              (priceNormal ? '<span class="lp-pp-normal">' + COP(priceNormal) + '</span>' : '') +
              '<span class="lp-pp-2x1">2×1</span>' +
            '</div>' +
            '<span class="lp-pp-now">' + COP(combo.price) + '</span>' +
            (priceSave > 0 ? '<span class="lp-pp-save">Ahorras ' + COP(priceSave) + ' · incluye 2 prendas</span>' : '') +
          '</div>' +
          '<div class="lp-bc-add-wrap">' +
            '<button class="lp-bc-add" data-lp-add="' + combo.id + '">Comprar</button>' +
            '<span class="lp-bc-shipping">🚚 Envío gratis</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    /* Eventos swatches */
    cardEl.querySelectorAll('[data-lp-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var gi    = btn.dataset.lpSwatch;
        var color = btn.dataset.lpColor;
        sel['opt' + gi] = color;
        var label = cardEl.querySelector('[data-lp-color-label="' + gi + '"]');
        if (label) label.textContent = color;
        cardEl.querySelectorAll('[data-lp-swatch="' + gi + '"]').forEach(function (b) {
          b.classList.toggle('is-sel', b.dataset.lpColor === color);
        });
        /* Actualizar la mitad de foto correspondiente */
        var photoKey = 'prenda' + (parseInt(gi, 10) + 1);
        var newSrc = imgMap[photoKey] && imgMap[photoKey][color];
        if (newSrc) {
          var photoImg = cardEl.querySelector('[data-lp-photo="' + gi + '"]');
          if (photoImg) {
            photoImg.classList.add('lp-fade');
            setTimeout(function () {
              photoImg.src = newSrc;
              photoImg.classList.remove('lp-fade');
            }, 200);
          }
        }
      });
    });

    /* Eventos tallas */
    cardEl.querySelectorAll('[data-lp-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sel.size = btn.dataset.lpSize;
        var label = cardEl.querySelector('[data-lp-size-label]');
        if (label) label.textContent = sel.size;
        cardEl.querySelectorAll('[data-lp-size]').forEach(function (b) {
          b.classList.toggle('is-sel', b.dataset.lpSize === sel.size);
        });
      });
    });

    /* Evento guía de tallas */
    var sgBtn = cardEl.querySelector('[data-lp-size-guide]');
    if (sgBtn) {
      sgBtn.addEventListener('click', function () {
        showSizeGuide(sgBtn.dataset.lpSizeGuide, combo.title);
      });
    }

    /* Evento agregar al carrito */
    var addBtn = cardEl.querySelector('[data-lp-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var color1 = sel['opt0'] || (colorOpts[0] && colorOpts[0].values[0]) || '';
        var color2 = sel['opt1'] || (colorOpts[1] && colorOpts[1].values[0]) || '';
        var size   = sel.size || '';

        var variant = combo.variants.find(function (v) {
          return v.available && (
            v.option1 === size || v.option2 === size || v.option3 === size
          );
        });
        if (!variant) {
          variant = combo.variants.find(function (v) { return v.available; });
        }
        if (!variant) {
          showToast('Talla no disponible. Elige otra opción.');
          return;
        }

        var properties = {};
        if (colorOpts[0] && color1) properties[colorOpts[0].name] = color1;
        if (colorOpts[1] && color2) properties[colorOpts[1].name] = color2;

        addBtn.disabled = true;
        addBtn.textContent = 'Procesando…';

        addVariantToCart(variant.id, 1, properties)
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            showToast('Error al agregar. Intenta de nuevo.');
            addBtn.disabled = false;
            addBtn.textContent = 'Comprar';
          });
      });
    }
  }

  /* ---- Upsell popup — 15% OFF en el 2do combo ---- */
  var UPSELL_CODE   = 'COMBO2-15OFF';
  var UPSELL_FACTOR = 0.85;

  function applyDiscountSilently(code) {
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;width:0;height:0;border:0;opacity:0;pointer-events:none;top:0;left:0';
    iframe.src = '/discount/' + code + '?redirect=/';
    iframe.onload = function () {
      setTimeout(function () {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 400);
    };
    document.body.appendChild(iframe);
  }

  function showUpsellPopup(currentComboId) {
    var combos  = ((window.__lpMpd || {}).combos) || [];
    var others  = combos.filter(function (c) { return c.id !== currentComboId; });
    if (!others.length) return;

    var itemsHtml = others.map(function (c) {
      var discPrice = Math.round(c.price * UPSELL_FACTOR);
      return '<div class="lp-upsell-item" data-lp-upsell-pick="' + c.id + '">' +
        (c.image
          ? '<img class="lp-upsell-item-img" src="' + c.image + '" alt="' + c.title + '" loading="lazy">'
          : '<div class="lp-upsell-item-img"></div>') +
        '<div class="lp-upsell-item-info">' +
          '<p class="lp-upsell-item-name">' + c.title + '</p>' +
          '<div class="lp-upsell-item-prices">' +
            '<span class="lp-upsell-item-orig">' + COP(c.price) + '</span>' +
            '<span class="lp-upsell-item-disc">' + COP(discPrice) + '</span>' +
            '<span class="lp-upsell-item-pct">-15%</span>' +
          '</div>' +
        '</div>' +
        '<button class="lp-upsell-item-btn">Armar este combo</button>' +
      '</div>';
    }).join('');

    var overlay = document.createElement('div');
    overlay.className = 'lp-upsell-overlay';
    overlay.innerHTML =
      '<div class="lp-upsell-modal" role="dialog" aria-modal="true" aria-label="Oferta especial 15% OFF">' +
        '<div class="lp-upsell-top">' +
          '<button class="lp-upsell-close" aria-label="Cerrar">&#x2715;</button>' +
          '<span class="lp-upsell-icon">&#x1F389;</span>' +
          '<h3 class="lp-upsell-title">¡Genial!<br>Tu combo está listo</h3>' +
          '<p class="lp-upsell-sub">Elige un combo y el <strong>15% OFF se aplica solo</strong></p>' +
          '<div class="lp-upsell-code-box">' +
            '<span class="lp-upsell-code">&#x2713;&nbsp;' + UPSELL_CODE + '</span>' +
            '<span class="lp-upsell-auto-badge">Auto</span>' +
          '</div>' +
        '</div>' +
        '<div class="lp-upsell-body">' +
          '<div class="lp-upsell-grid">' + itemsHtml + '</div>' +
          '<button class="lp-upsell-skip" data-lp-upsell-skip>No gracias, continuar</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    /* Animar entrada */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    });

    /* Cerrar con overlay, X o "No gracias" */
    overlay.querySelector('.lp-upsell-close').addEventListener('click', closeUpsellPopup);
    overlay.querySelector('[data-lp-upsell-skip]').addEventListener('click', closeUpsellPopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeUpsellPopup();
    });

    /* Seleccionar combo → aplicar descuento automáticamente + pre-cargar en builder */
    overlay.querySelectorAll('[data-lp-upsell-pick]').forEach(function (item) {
      item.addEventListener('click', function () {
        var id = Number(item.dataset.lpUpsellPick);
        closeUpsellPopup();

        /* Aplicar el descuento en Shopify via iframe silencioso */
        applyDiscountSilently(UPSELL_CODE);

        builderState.comboId = id;
        var tabsEl    = document.querySelector('#lp-build-tabs');
        var cardEl    = document.querySelector('#lp-build-card');
        var combosAll = ((window.__lpMpd || {}).combos) || [];

        if (tabsEl) {
          tabsEl.querySelectorAll('[data-lp-tab]').forEach(function (b) {
            var active = Number(b.dataset.lpTab) === id;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active);
          });
        }
        if (cardEl) renderCard(cardEl, combosAll);
        scrollToId('lp-builder');
        showToast('¡15% OFF aplicado! Arma tu 2do combo');
      });
    });
  }

  function closeUpsellPopup() {
    var overlay = document.querySelector('.lp-upsell-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 280);
  }

  /* ---- Guía de tallas ---- */
  function showSizeGuide(imageUrl, comboTitle) {
    var existing = document.querySelector('.lp-sg-overlay');
    if (existing) existing.parentNode.removeChild(existing);

    var overlay = document.createElement('div');
    overlay.className = 'lp-sg-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Guía de tallas');
    overlay.innerHTML =
      '<div class="lp-sg-modal">' +
        '<div class="lp-sg-head">' +
          '<h4>Guía de tallas</h4>' +
          '<button class="lp-sg-close" aria-label="Cerrar">&#x2715;</button>' +
        '</div>' +
        '<div class="lp-sg-img-wrap">' +
          '<img src="' + imageUrl + '" alt="Guía de tallas ' + (comboTitle || '') + '" loading="lazy">' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    });

    overlay.querySelector('.lp-sg-close').addEventListener('click', closeSizeGuide);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSizeGuide();
    });
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') { closeSizeGuide(); document.removeEventListener('keydown', escHandler); }
    });
  }

  function closeSizeGuide() {
    var overlay = document.querySelector('.lp-sg-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 240);
  }

  /* ---- Mapa de imágenes por prenda/color (alt: "CB:prenda1:Blanco") ---- */
  function buildImageMap(images) {
    var map = {};
    (images || []).forEach(function (img) {
      var m = (img.alt || '').trim().match(/prenda(\d+):(.+)$/i);
      if (m) {
        var key = 'prenda' + m[1];
        var color = m[2].trim();
        if (!map[key]) map[key] = {};
        map[key][color] = img.url;
      }
    });
    return map;
  }

  /* ---- FAQ ---- */
  function initFaq(root) {
    root.querySelectorAll('[data-lp-faq-item]').forEach(function (item) {
      var btn = item.querySelector('.lp-faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        root.querySelectorAll('[data-lp-faq-item]').forEach(function (i) {
          i.classList.remove('is-open');
          var q = i.querySelector('.lp-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---- Scroll links ---- */
  function initScrollLinks() {
    document.querySelectorAll('[data-lp-scroll]').forEach(function (el) {
      el.addEventListener('click', function () {
        scrollToId(el.dataset.lpScroll);
      });
    });
  }

  /* ---- Pick combo desde cards ---- */
  function initPickCombo(root) {
    root.querySelectorAll('[data-lp-pick-combo]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = Number(btn.dataset.lpPickCombo);
        builderState.comboId = id;

        var cardEl = document.querySelector('#lp-build-card');
        var combos = ((window.__lpMpd || {}).combos) || [];

        if (cardEl) renderCard(cardEl, combos);
        scrollToId('lp-builder');
      });
    });
  }

  /* ---- Init ---- */
  function init() {
    if (!document.querySelector('[data-lp-mpd]')) return;

    initBuilder(document);
    initFaq(document);
    initScrollLinks();
    initPickCombo(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
